import { Component, inject } from '@angular/core';
import { DuplicatesComponent } from './partials/duplicates/duplicates.component';
import { RemovedComponent } from './partials/removed/removed.component';
import { UpdatedComponent } from './partials/updated/updated.component';
import { OverviewComponent } from './partials/overview/overview.component';
import { InvalidsComponent } from './partials/invalids/invalids.component';
import { LocalCsvService } from '../../../../../services/local-csv/local-csv.service';
import { CustomizableTabsComponent, CustomizableTab } from '../../../../../components/ui/customizable-tabs/customizable-tabs.component';

type TReviewView = 'overview' | 'duplicated' | 'removed' | 'updated' | 'invalids';

const VIEW_MAP: TReviewView[] = ['overview', 'duplicated', 'removed', 'updated', 'invalids'];

@Component({
  selector: 'csv-phone-numbers-review',
  standalone: true,
  imports: [
    DuplicatesComponent,
    RemovedComponent,
    UpdatedComponent,
    OverviewComponent,
    InvalidsComponent,
    CustomizableTabsComponent,
  ],
  templateUrl: './csv-phone-number-review.component.html',
  styleUrl: './csv-phone-number-review.component.css',
})
export class CsvPhoneNumberReviewComponent {
  localCSVService = inject(LocalCsvService);

  currentView: TReviewView = 'overview';
  activeIndex = 0;

  get tabs(): CustomizableTab[] {
    return [
      { title: 'Overview' },
      { title: 'Repeated', count: this.localCSVService.getDuplicates.length || undefined },
      { title: 'Removed',  count: this.localCSVService.getRemoved.length    || undefined },
      { title: 'Edited',   count: this.localCSVService.getUpdated.length    || undefined },
      { title: 'Invalid',  count: this.localCSVService.getInvalids.length   || undefined },
    ];
  }

  onTabChange(index: number): void {
    this.activeIndex = index;
    this.currentView = VIEW_MAP[index];
  }

  /** Jump to a tab from a link in the overview, e.g. "See invalid numbers". */
  openTab(view: TReviewView): void {
    const index = VIEW_MAP.indexOf(view);
    if (index >= 0) this.onTabChange(index);
  }
}
